import React from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Skeleton,
  Box
} from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const getLevelChip = (margin) => {
  if (margin < 60) return <Chip label="Crítico" color="error" size="small" />;
  if (margin < 75) return <Chip label="Bajo" color="warning" size="small" />;
  if (margin < 80) return <Chip label="Medio" sx={{ bgcolor: 'gold', color: 'black' }} size="small" />;
  return <Chip label="Alto" color="success" size="small" />;
};

const ProfitableProductsTable = ({
  data = [],
  loading,
  sortBy = 'margin',
  sortOrder = 'asc',
  title = 'Productos',
}) => {
  const sortedData = [...data].sort((a, b) =>
    sortOrder === 'asc' ? a[sortBy] - b[sortBy] : b[sortBy] - a[sortBy]
  );

  return (
    <Paper elevation={3} sx={{ p: 2, height: 335, display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle1" gutterBottom>{title}</Typography>
      <TableContainer sx={{ flex: 1, overflowY: 'auto' }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Producto</TableCell>
              <TableCell>Precio</TableCell>
              <TableCell>Costo</TableCell>
              <TableCell>Margen</TableCell>
              <TableCell>Nivel</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              [...Array(5)].map((_, i) => (
                <TableRow key={i}>
                  <TableCell><Skeleton width="80%" /></TableCell>
                  <TableCell><Skeleton width="60%" /></TableCell>
                  <TableCell><Skeleton width="60%" /></TableCell>
                  <TableCell><Skeleton width="40%" /></TableCell>
                  <TableCell><Skeleton width="50%" /></TableCell>
                </TableRow>
              ))
            ) : sortedData.length > 0 ? (
              sortedData.map((prod) => (
                <TableRow key={prod.name}>
                  <TableCell>{prod.name}</TableCell>
                  <TableCell>{formatMoney(prod.salePrice)}</TableCell>
                  <TableCell>{formatMoney(prod.cost)}</TableCell>
                  <TableCell>{prod.margin}%</TableCell>
                  <TableCell>{getLevelChip(prod.margin)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography variant="body2" color="textSecondary">
                    No hay datos disponibles.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ProfitableProductsTable;
